<template>
  <div class="listContainer proContainer" @keyup.enter="onSearch">
    <!-- 面包屑 -->
    <a-breadcrumb class="breadcrumb">
      <span slot="separator">></span>
      <a-breadcrumb-item>资金管理</a-breadcrumb-item>
      <a-breadcrumb-item>
        <a @click="showInUserList">项目设置</a>
      </a-breadcrumb-item>
    </a-breadcrumb>
    <!-- 面包屑 end   -->
    <!-- 增加&搜索 -->
    <section v-show="!hideInUserEdit">
      <section class="searchBox">
        <div>
          <p>城市：</p>
          <area-select
            type="text"
            :data="pcaa"
            v-model="cityVal"
            area-select
          ></area-select>
        </div>
        <div>
          <p>项目名称：</p>
          <a-input
            v-model="nameSearch"
            style="width:160px"
            placeholder="请输入项目名称"
          />
        </div>
        <div>
          <a-button @click="clearSearch" style="margin-right:20px;"
            >重置</a-button
          >
          <a-button type="primary" icon="search" @click="onSearch"
            >搜索</a-button
          >
        </div>
      </section>
      <!-- 增加&搜索 end-->
      <section class="tableStyles">
        <table>
          <thead>
            <tr>
              <th v-for="item in thList" :key="item">{{ item }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-show="data == ''">
              <td></td>
              <td></td>
              <td>暂无</td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr v-show="data.length > 0" v-for="(item, i) in data" :key="i">
              <td>{{ item.trade_info.trade_name }}</td>
              <td>
                <span
                  v-if="
                    item.province == '上海市' ||
                      item.province == '重庆市' ||
                      item.province == '天津市' ||
                      item.province == '北京市'
                  "
                  >{{ item.city }}</span
                >
                <span v-else>{{ item.province + item.city }}</span>
              </td>
              <td>{{ item.project_name }}</td>
              <td>{{ item.proportion + "%" }}</td>
              <td>{{ item.user_names }}</td>
              <td class="operation">
                <a @click="edit(item)">编辑</a>
              </td>
            </tr>
          </tbody>
        </table>
      </section>
      <div class="paginationStyle" :loading="loading">
        <a-pagination
          showQuickJumper
          :defaultCurrent="page"
          :total="pagination.total"
          @change="onChange"
          :current="page"
        />
        <span>{{ "共：" + pagination.total + "条" }}</span>
      </div>
    </section>
    <!-- 编辑 -->
    <projectEdit
      v-on:hideInEdit="hideInEdit"
      v-if="hideInUserEdit"
      :editDetail="editDetail"
    />
    <!-- 编辑  end-->
  </div>
</template>
<script>
import { pcaa } from "area-data";
import axios from "axios";
import projectEdit from "@/components/money/projectEdit"; //编辑
import { mapState } from "vuex";

export default {
  components: {
    projectEdit
  },
  data() {
    return {
      data: {},
      loading: false,
      page: 1,
      pagination: {},
      query_field: "",
      hideInUserEdit: false,
      editDetail: {},
      totalPage: Number,
      nameSearch: "",
      thList: ["所属行业", "城市", "项目名称", "预支比例", "负责人", "操作"],
      pcaa: pcaa,
      cityVal: [],
      tradeList: [],
      tradeVal: "",
      sign_agreement_id: [],
      contractList: []
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  mounted() {
    this.getData(); //获取列表
    this.getTrade(); //获取行业
    this.getContract(); //获取合同
  },
  methods: {
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    getContract() {
      let url = this.httpsBasic.url + this.httpsBasic.user + "Sign/getList";
      let params = {
        current_page: this.page,
        per_page: 10000,
        query_field: this.nameSearch,
        token: window.localStorage.getItem("xnwfPcToken")
      };
      axios.post(url, params).then(res => {
        this.contractList = res.data.data.data;
        // console.log(this.contractList);
      });
    },
    getTrade() {
      let url = this.httpsBasic.url + this.httpsBasic.trade + "Trade/tradeList";
      //   console.log(url)
      let pramas = {
        token: window.localStorage.getItem("xnwfPcToken"),
        current_page: 1,
        per_page: 1000
      };
      axios.post(url, pramas).then(res => {
        if (res.data.code == 200) {
          this.tradeList = res.data.data.data;
        }
        // console.log(res);
      });
    },
    onChange(pageNumber) {
      // console.log("Page: ", pageNumber);
      this.page = pageNumber;
      this.getData();
    },
    reload() {
      this.$nextTick(function() {
        this.getData();
      });
    },
    hideInEdit(msg) {
      this.hideInUserEdit = msg;
      this.reload();
    },
    showInUserList() {
      this.hideInUserEdit = false;
    },
    onSearch(value) {
      this.page = 1;
      // this.query_field = value;
      this.getData();
      // console.log(value);
    },
    getData() {
      let city;
      if (this.cityVal != "") {
        if (
          this.cityVal[0] == "北京市" ||
          this.cityVal[0] == "上海市" ||
          this.cityVal[0] == "天津市" ||
          this.cityVal[0] == "重庆市"
        ) {
          city = this.cityVal[0];
        } else {
          city = this.cityVal[1];
        }
      }
      this.loading = true;
      this.data = [];
      let url =
        this.httpsBasic.url +
        this.httpsBasic.trade +
        "Project/financeProjectList";
      let pramas = {
        current_page: this.page,
        per_page: 10,
        query_field: this.nameSearch,
        token: window.localStorage.getItem("xnwfPcToken"),
        trade_id: this.tradeVal,
        city: city
      };
      if (this.cityVal == "") {
        delete pramas.city;
      }
      if (this.tradeVal == "") {
        delete pramas.trade_id;
      }
      axios
        .post(url, pramas)
        .then(res => {
          if (res.data.code == 200) {
            this.data = res.data.data.data;
            // console.log(this.data);
            this.loading = false;
            const pagination = { ...this.pagination };
            pagination.total = res.data.data.total;
            this.pagination = pagination;
          } else {
            this.$message.warning(res.data.message);
            this.loading = false;
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    clearSearch() {
      this.cityVal = [];
      this.tradeVal = "";
      this.nameSearch = "";
      this.sign_agreement_id = [];
      this.page = 1;
      this.getData();
    },
    edit(detail) {
      this.hideInUserEdit = true;
      this.editDetail = detail;
    }
  }
};
</script>
<style lang="less" scoped>
@import url(../../style/listBasic.less);
.listContainer {
  .searchBox {
    display: block;
    padding: 14px 2%;
    > div {
      display: inline-block;
      margin-right: 20px;
      margin-bottom: 10px;
      div,
      input,
      p {
        display: inline-block;
        vertical-align: top;
        line-height: 30px;
      }
      button {
        vertical-align: top;
      }
    }
  }
}
</style>
<style lang="less">
.ant-table {
  min-height: 58vh;
}
.proContainer {
  .area-select .area-selected-trigger {
    padding: 0 20px 0 12px;
  }
  .area-select.medium {
    width: 100px;
  }
}
</style>
